import config from '../assets/config.json';

export default config;
